var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 0.898438L10.4766 5.27344C10.832 5.60156 10.832 6.17578 10.4766 6.50391C10.1484 6.85938 9.57422 6.85938 9.24609 6.50391L6.375 3.63281V12C6.375 12.4922 5.96484 12.875 5.5 12.875C5.00781 12.875 4.625 12.4922 4.625 12V3.63281L1.72656 6.50391C1.39844 6.85938 0.824219 6.85938 0.496094 6.50391C0.140625 6.17578 0.140625 5.60156 0.496094 5.27344L4.87109 0.898438C5.19922 0.542969 5.77344 0.542969 6.10156 0.898438Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLight);
export default __webpack_public_path__ + "static/media/arrow_up_light.22777367236341cceafd373b93d7204a.svg";
export { ForwardRef as ReactComponent };